import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(
          _vm._s(
            _vm.mode == "create"
              ? _vm.$t("data_quality.dataplex.quality.create_quality")
              : _vm.mode == "edit"
              ? _vm.$t("data_quality.dataplex.quality.update_quality")
              : _vm.$t("data_quality.dataplex.quality.view_quality")
          )
        ),
      ]),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, { staticClass: "pa-0" }, [
                _vm._v(
                  _vm._s(_vm.$t("data_quality.dataplex.quality.description"))
                ),
              ]),
            ],
            1
          ),
          _c("template", { slot: "actions" }),
        ],
        2
      ),
      _c(
        VCard,
        [
          _c(
            VCardText,
            [
              _c(
                VForm,
                { ref: "form_quality" },
                [
                  _c(
                    "div",
                    { staticClass: "flex align-center mb-2" },
                    [
                      _c(
                        VTabs,
                        {
                          model: {
                            value: _vm.tab,
                            callback: function ($$v) {
                              _vm.tab = $$v
                            },
                            expression: "tab",
                          },
                        },
                        [
                          _c(VTab, { attrs: { disabled: !_vm.view } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "data_quality.dataplex.quality.tab_general"
                                )
                              )
                            ),
                          ]),
                          _c(VTab, { attrs: { disabled: !_vm.view } }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "data_quality.dataplex.quality.tab_columns"
                                )
                              )
                            ),
                          ]),
                          _vm.view
                            ? _c(VTab, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "data_quality.dataplex.quality.tab_execution"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                          _c(VSpacer),
                          _c(
                            VBtn,
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.onCancelar },
                            },
                            [_c(VIcon, [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    VTabsItems,
                    {
                      model: {
                        value: _vm.tab,
                        callback: function ($$v) {
                          _vm.tab = $$v
                        },
                        expression: "tab",
                      },
                    },
                    [
                      _c(
                        VTabItem,
                        { staticClass: "mt-3" },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.name"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view,
                                      disabled: _vm.view,
                                      rules: _vm.rules.display_name,
                                      prefix:
                                        !_vm.view && !_vm.edit
                                          ? _vm.PREFIX
                                          : "",
                                    },
                                    on: { keyup: _vm.onChangeName },
                                    model: {
                                      value: _vm.quality.display_name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.quality,
                                          "display_name",
                                          $$v
                                        )
                                      },
                                      expression: "quality.display_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [_vm._v(_vm._s("ID (Dataplex)"))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    key: _vm.key_data_scan_id,
                                    attrs: {
                                      filled: "",
                                      readonly: "",
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view || _vm.edit,
                                      rules: _vm.rules.data_scan_id,
                                    },
                                    model: {
                                      value: _vm.quality.data_scan_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.quality,
                                          "data_scan_id",
                                          $$v
                                        )
                                      },
                                      expression: "quality.data_scan_id",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.description"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(VTextarea, {
                                    attrs: {
                                      filled: _vm.view,
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view,
                                      rules: _vm.rules.description,
                                      rows: 2,
                                      hint: "(Opcional)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.quality.description,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.quality,
                                          "description",
                                          $$v
                                        )
                                      },
                                      expression: "quality.description",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.table"
                                          ) + " (project.dataset.table)"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(VTextField, {
                                    key: _vm.key_input_table_input,
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: _vm.view || _vm.edit,
                                      disabled: _vm.view || _vm.edit,
                                      rules: _vm.rules.table_input,
                                      error: _vm.custom_error.table_input.error,
                                      "error-messages":
                                        _vm.custom_error.table_input.message,
                                    },
                                    on: {
                                      change: _vm.onChangeTableInput,
                                      blur: _vm.onDetailTable,
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "append-outer",
                                        fn: function () {
                                          return [
                                            _vm.custom_error.table_input
                                              .error == false
                                              ? _c(
                                                  VIcon,
                                                  {
                                                    attrs: { color: "success" },
                                                  },
                                                  [_vm._v("mdi-check-all")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "progress",
                                        fn: function () {
                                          return [
                                            _vm.custom_error.table_input.loading
                                              ? _c(VProgressLinear, {
                                                  attrs: {
                                                    color: "primary",
                                                    value: "0",
                                                    indeterminate:
                                                      _vm.custom_error
                                                        .table_input.loading,
                                                    height: _vm.custom_error
                                                      .table_input.loading
                                                      ? 1
                                                      : 0,
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                    model: {
                                      value: _vm.quality.table_input,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.quality,
                                          "table_input",
                                          $$v
                                        )
                                      },
                                      expression: "quality.table_input",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.profiling.fields.table_last_modification"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    key: _vm.key_input_table_input_last,
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      filled: "",
                                      disabled: "",
                                      value: _vm.last_modification_table,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.sample_size"
                                          ) + " (%)"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view,
                                      min: "1",
                                      max: "100",
                                      type: "number",
                                      rules: [
                                        function (v) {
                                          return (
                                            !!v ||
                                            _vm.$t("common.field_required")
                                          )
                                        },
                                      ],
                                      filled: _vm.view,
                                    },
                                    model: {
                                      value: _vm.quality.sampling_percent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.quality,
                                          "sampling_percent",
                                          $$v
                                        )
                                      },
                                      expression: "quality.sampling_percent",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.row_filter"
                                          ) + " (discount_pct > 50)"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "4" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      dense: "",
                                      outlined: "",
                                      disabled: _vm.view,
                                      filled: _vm.view,
                                      hint: "(Opcional)",
                                      "persistent-hint": "",
                                    },
                                    model: {
                                      value: _vm.quality.row_filter,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.quality, "row_filter", $$v)
                                      },
                                      expression: "quality.row_filter",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.scope"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(
                                    VRadioGroup,
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        row: "",
                                        disabled: _vm.view,
                                        small: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.quality.scope,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.quality, "scope", $$v)
                                        },
                                        expression: "quality.scope",
                                      },
                                    },
                                    [
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.quality.fields.scope_incremental"
                                          ),
                                          value: "INCREMENTAL",
                                        },
                                      }),
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.quality.fields.scope_complete"
                                          ),
                                          value: "FULL",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(VCol, { attrs: { cols: "2" } }),
                              _c(VCol, { attrs: { cols: "10" } }, [
                                _vm.quality.scope == "INCREMENTAL"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "fieldset p-3 mb-1" },
                                      [
                                        _c("legend"),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.quality.fields.scope_period"
                                                    ),
                                                    items: _vm.scope_periods,
                                                    dense: "",
                                                    outlined: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "hide-details": "auto",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          _vm.$t(
                                                            "common.field_required"
                                                          )
                                                        )
                                                      },
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.quality.scope_period,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.quality,
                                                        "scope_period",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "quality.scope_period",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm.quality.scope == "INCREMENTAL"
                                              ? _c(
                                                  VCol,
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(VAutocomplete, {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "data_quality.dataplex.quality.fields.scope_column"
                                                        ),
                                                        items: _vm.time_columns,
                                                        outlined: "",
                                                        dense: "",
                                                        filled: _vm.view,
                                                        disabled: _vm.view,
                                                        "item-text": "name",
                                                        "item-value": "name",
                                                        "hide-details": "auto",
                                                        rules: [
                                                          function (v) {
                                                            return (
                                                              !!v ||
                                                              _vm.$t(
                                                                "common.field_required"
                                                              )
                                                            )
                                                          },
                                                        ],
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.quality
                                                            .scope_column,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.quality,
                                                            "scope_column",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "quality.scope_column",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm.quality.scope == "INCREMENTAL"
                                              ? _c(
                                                  VCol,
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(VCheckbox, {
                                                      staticClass: "mt-0",
                                                      attrs: {
                                                        outlined: "",
                                                        dense: "",
                                                        label: _vm.$t(
                                                          "data_quality.dataplex.scope_closed_label"
                                                        ),
                                                        "persistent-hint": "",
                                                        hint: _vm.$t(
                                                          "data_quality.dataplex.scope_closed_hint"
                                                        ),
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.quality
                                                            .scope_closed,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.quality,
                                                            "scope_closed",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "quality.scope_closed",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.schedule_execution"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c(
                                    VRadioGroup,
                                    {
                                      staticClass: "mt-1",
                                      attrs: {
                                        row: "",
                                        disabled: _vm.view,
                                        small: "",
                                        dense: "",
                                      },
                                      model: {
                                        value: _vm.quality.cron_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.quality,
                                            "cron_type",
                                            $$v
                                          )
                                        },
                                        expression: "quality.cron_type",
                                      },
                                    },
                                    [
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.quality.fields.schedule_unique"
                                          ),
                                          value: "UNIQUE",
                                        },
                                      }),
                                      _c(VRadio, {
                                        attrs: {
                                          label: _vm.$t(
                                            "data_quality.dataplex.quality.fields.schedule_cron"
                                          ),
                                          value: "CRON",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(VCol, { attrs: { cols: "2" } }),
                              _c(VCol, { attrs: { cols: "10" } }, [
                                _vm.quality.cron_type == "CRON"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "fieldset p-3 mb-1" },
                                      [
                                        _c("legend"),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.quality.fields.schedule_period"
                                                    ),
                                                    items: _vm.cron_periods,
                                                    dense: "",
                                                    outlined: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "hide-details": "auto",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          _vm.$t(
                                                            "common.field_required"
                                                          )
                                                        )
                                                      },
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.quality.cron_period,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.quality,
                                                        "cron_period",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "quality.cron_period",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm.quality.cron_period ==
                                              _vm.PERIODS.ONE_MONTH ||
                                            _vm.quality.cron_period ==
                                              _vm.PERIODS.ONE_WEEK
                                              ? _c(
                                                  VCol,
                                                  { attrs: { cols: "3" } },
                                                  [
                                                    _c(VSelect, {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "data_quality.dataplex.quality.fields.schedule_day"
                                                        ),
                                                        items:
                                                          _vm.quality
                                                            .cron_period ==
                                                          _vm.PERIODS.ONE_MONTH
                                                            ? _vm.cron_days
                                                            : _vm.cron_days_week,
                                                        dense: "",
                                                        outlined: "",
                                                        disabled: _vm.view,
                                                        filled: _vm.view,
                                                        "hide-details": "auto",
                                                        rules: [
                                                          function (v) {
                                                            return (
                                                              !!v ||
                                                              _vm.$t(
                                                                "common.field_required"
                                                              )
                                                            )
                                                          },
                                                        ],
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.quality.cron_day,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.quality,
                                                            "cron_day",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "quality.cron_day",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VSelect, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.quality.fields.schedule_hour"
                                                    ),
                                                    items: _vm.cron_hours,
                                                    dense: "",
                                                    outlined: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "hide-details": "auto",
                                                    rules: [
                                                      function (v) {
                                                        return (
                                                          !!v ||
                                                          _vm.$t(
                                                            "common.field_required"
                                                          )
                                                        )
                                                      },
                                                    ],
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.quality.cron_hour,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.quality,
                                                        "cron_hour",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "quality.cron_hour",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm.quality.cron_type == "UNIQUE"
                                  ? _c(
                                      "fieldset",
                                      { staticClass: "fieldset p-3 mb-1" },
                                      [
                                        _c("legend"),
                                        _c(
                                          VSubheader,
                                          {
                                            staticClass:
                                              "font-weight-bold mb-1",
                                          },
                                          [_vm._v("Rango de datos a procesar")]
                                        ),
                                        _vm.numRowsTable > _vm.numRowsAllowed
                                          ? _c(
                                              VAlert,
                                              {
                                                staticClass: "py-1 mb-2",
                                                attrs: {
                                                  type: "warning",
                                                  dense: "",
                                                  text: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.rowsLimitText)
                                                ),
                                              ]
                                            )
                                          : _c(
                                              VAlert,
                                              {
                                                staticClass: "py-1 mb-2",
                                                attrs: {
                                                  type: "info",
                                                  dense: "",
                                                  text: "",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Opcional. Permite limitar la ejecución a un rango de fechas respecto a la columna de tiempo seleccionada."
                                                ),
                                              ]
                                            ),
                                        _c(
                                          VRow,
                                          [
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(VAutocomplete, {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "data_quality.dataplex.quality.fields.schedule_column"
                                                    ),
                                                    items: _vm.time_columns,
                                                    outlined: "",
                                                    dense: "",
                                                    filled: _vm.view,
                                                    disabled: _vm.view,
                                                    "item-text": "name",
                                                    "item-value": "name",
                                                    "hide-details": "auto",
                                                    id: "column_time",
                                                    name: "column_time",
                                                    rules:
                                                      _vm.numRowsTable >
                                                      _vm.numRowsAllowed
                                                        ? [_vm.rules.required]
                                                        : [],
                                                    hint:
                                                      _vm.numRowsTable >
                                                      _vm.numRowsAllowed
                                                        ? "Requerido para tablas grandes"
                                                        : "Opcional",
                                                    "persistent-hint": "",
                                                    bottom: "",
                                                    right: "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.quality.column_time,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.quality,
                                                        "column_time",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "quality.column_time",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  "TextFieldCalendarComponent",
                                                  {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "data_quality.dataplex.quality.fields.date_from"
                                                      ),
                                                      disabled: _vm.view,
                                                      filled: _vm.view,
                                                      rules: _vm.quality
                                                        .column_time
                                                        ? [
                                                            function (v) {
                                                              return (
                                                                !!v ||
                                                                _vm.$t(
                                                                  "common.field_required"
                                                                )
                                                              )
                                                            },
                                                          ]
                                                        : [],
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quality
                                                          .column_time_from,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.quality,
                                                          "column_time_from",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quality.column_time_from",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  "TextFieldCalendarComponent",
                                                  {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "data_quality.dataplex.quality.fields.date_till"
                                                      ),
                                                      disabled: _vm.view,
                                                      filled: _vm.view,
                                                      rules: _vm.quality
                                                        .column_time
                                                        ? [
                                                            function (v) {
                                                              return (
                                                                !!v ||
                                                                _vm.$t(
                                                                  "common.field_required"
                                                                )
                                                              )
                                                            },
                                                          ]
                                                        : [],
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.quality
                                                          .column_time_until,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.quality,
                                                          "column_time_until",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "quality.column_time_until",
                                                    },
                                                  }
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    VSubheader,
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.fields.notification"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { attrs: { cols: "10" } },
                                [
                                  _c("TextFieldRecipientsComponent", {
                                    attrs: {
                                      disabled: _vm.view,
                                      filled: _vm.view,
                                    },
                                    model: {
                                      value: _vm.quality.recipients,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.quality, "recipients", $$v)
                                      },
                                      expression: "quality.recipients",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          !_vm.view
                            ? _c(VRow, { attrs: { justify: "center" } }, [
                                _c(
                                  "div",
                                  { staticClass: "mb-2" },
                                  [
                                    _c(
                                      VBtn,
                                      {
                                        staticClass: "default mr-1",
                                        attrs: {
                                          id: "btn_next_tab",
                                          name: "tn_next_tab",
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.nextTab()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("botones.boton_siguiente")
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        { staticClass: "mt-3" },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { staticClass: "col-12 text-right" },
                                [
                                  _vm.view == false
                                    ? _c(
                                        VBtn,
                                        {
                                          staticClass:
                                            "ml-1 btn-inca-secondary",
                                          attrs: { outlined: "", dense: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openDialogAddColumn()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            VIcon,
                                            { attrs: { small: "" } },
                                            [_vm._v("icon-add")]
                                          ),
                                          _vm._v(
                                            _vm._s(_vm.$t("botones.boton_add"))
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "col-12" },
                                [
                                  _c(VDataTable, {
                                    key: _vm.key_table_columns,
                                    staticClass: "table-inca",
                                    attrs: {
                                      headers: _vm.headers_columns,
                                      items: _vm.columns,
                                      "hide-default-footer": "",
                                      "items-per-page":
                                        _vm.pagination_columns.limit,
                                      page: _vm.pagination_columns.current,
                                    },
                                    on: {
                                      pagination: function ($event) {
                                        _vm.pagination_columns.total =
                                          $event.itemsLength
                                      },
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.pagination_columns,
                                          "current",
                                          $event
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.parameters",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("DataplexParameterComponent", {
                                              attrs: { parameters: item.rule },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.dimension",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.rule.dimension_name
                                                    ? item.rule.dimension_name
                                                    : item.rule.dimension
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.expectation",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.rule.expectation_name
                                                    ? item.rule.expectation_name
                                                    : item.rule.expectation
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.actions",
                                        fn: function (ref) {
                                          var item = ref.item
                                          var index = ref.index
                                          return [
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onEditColumn(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-edit")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onViewColumn(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-view")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { icon: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onRemoveColumn(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  { attrs: { small: "" } },
                                                  [_vm._v("icon-delete")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("pagination-vue", {
                                    attrs: {
                                      pagination: _vm.pagination_columns,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VRow, { attrs: { justify: "center" } }, [
                            _c(
                              "div",
                              { staticClass: "mb-2" },
                              [
                                _vm.view == false
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "default mr-1",
                                        attrs: {
                                          id: "link_go_list_qualities",
                                          name: "link_go_list_qualities",
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.prevTab()
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btns.previous")))]
                                    )
                                  : _vm._e(),
                                _vm.view == false && _vm.tab != 2
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "default mr-1",
                                        attrs: {
                                          id: "btn_next_tab",
                                          name: "tn_next_tab",
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.nextTab()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("botones.boton_siguiente")
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.view == false && _vm.tab != 2
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "primary mr-1",
                                        attrs: {
                                          id: "btn_save_quality",
                                          name: "btn_save_quality",
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.edit
                                              ? _vm.onUpdateQuality()
                                              : _vm.onSaveQuality()
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btns.save")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VTabItem,
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                [
                                  _c(VDataTable, {
                                    key: _vm.key_table_executions,
                                    staticClass: "table-inca",
                                    attrs: {
                                      headers: _vm.headers_executions,
                                      items: _vm.executions,
                                      "sort-by":
                                        _vm.pagination_executions.sort_by,
                                      "sort-desc":
                                        _vm.pagination_executions.sort_desc,
                                      "hide-default-footer": true,
                                      page: _vm.pagination_executions.current,
                                    },
                                    on: {
                                      "update:page": function ($event) {
                                        return _vm.$set(
                                          _vm.pagination_executions,
                                          "current",
                                          $event
                                        )
                                      },
                                      pagination: function ($event) {
                                        _vm.pagination_executions.total =
                                          $event.itemsLength
                                      },
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "item.state",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.DATAPLEX_STATES[
                                                    item.state
                                                  ]
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.startTime",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    item.created_date
                                                  )
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.endTime",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(item.endTime)
                                                )
                                              ),
                                            ]),
                                          ]
                                        },
                                      },
                                      {
                                        key: "item.actions",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { text: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onPingExecution(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  [
                                                    _vm._v("mdi-broadcast"),
                                                    _c("PING"),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              VBtn,
                                              {
                                                staticClass: "btn-icon-inca",
                                                attrs: { text: "", small: "" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onViewDetailExecution(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  VIcon,
                                                  [
                                                    _vm._v("icon-view"),
                                                    _c("DETALLE"),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _c("pagination-vue", {
                                    attrs: {
                                      pagination: _vm.pagination_executions,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VRow, { attrs: { justify: "center" } }, [
                            _c(
                              "div",
                              { staticClass: "mb-2" },
                              [
                                _vm.view == false
                                  ? _c(
                                      VBtn,
                                      {
                                        staticClass: "default mr-1",
                                        attrs: {
                                          id: "link_go_list_qualities",
                                          name: "link_go_list_qualities",
                                          outlined: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.prevTab()
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(_vm.$t("btns.previous")))]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "dialogs-component",
        {
          ref: "DIALOG_DETAIL_EXECUTION",
          attrs: { title: "Detalle de Ejecución", width: 1400 },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("QualityExecutionDetailComponent", {
                key: _vm.key_table_execution_details,
                attrs: {
                  items:
                    _vm.execution_selected.dataQualityResult &&
                    _vm.execution_selected.dataQualityResult.rules
                      ? _vm.execution_selected.dataQualityResult.rules
                      : [],
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "dialogs-component",
        {
          ref: "DIALOG_ADD_COLUMN",
          attrs: {
            title: _vm.edit_rule
              ? _vm.$t(
                  "data_quality.dataplex.quality.column_field.update_column"
                )
              : _vm.view_rule
              ? _vm.$t("data_quality.dataplex.quality.column_field.view_column")
              : _vm.$t("data_quality.dataplex.quality.column_field.add_column"),
            width: 800,
          },
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c(
                VForm,
                { ref: "form_rule_add" },
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "data_quality.dataplex.quality.column_field.select_column"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          !_vm.edit_rule && !_vm.view_rule
                            ? _c(VAutocomplete, {
                                attrs: {
                                  items:
                                    _vm.table_input && _vm.table_input.schema
                                      ? _vm.table_input.schema.fields
                                      : [],
                                  multiple: "",
                                  outlined: "",
                                  dense: "",
                                  "item-text": "name",
                                  "item-value": "name",
                                  "hide-details": "auto",
                                  chips: "",
                                  rules: [
                                    function (v) {
                                      return !!v || "Campo requerido."
                                    },
                                  ],
                                },
                                on: { change: _vm.onSelectColumn },
                                model: {
                                  value: _vm.column_selected.columns,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.column_selected,
                                      "columns",
                                      $$v
                                    )
                                  },
                                  expression: "column_selected.columns",
                                },
                              })
                            : _vm._e(),
                          _vm.edit_rule || _vm.view_rule
                            ? _c(VTextField, {
                                attrs: {
                                  disabled: "",
                                  outlined: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.column_selected.column,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.column_selected, "column", $$v)
                                  },
                                  expression: "column_selected.column",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "3" } },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "data_quality.dataplex.quality.column_field.select_rule"
                                  )
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "9" } },
                        [
                          !_vm.edit_rule && !_vm.view_rule
                            ? _c(VSelect, {
                                attrs: {
                                  items: _vm.dataplex_rules,
                                  dense: "",
                                  outlined: "",
                                  "item-value": "id",
                                  "item-text": "name",
                                  multiple: "",
                                  "return-object": "",
                                  rules: [
                                    function (v) {
                                      return !!v || "Campo requerido."
                                    },
                                  ],
                                },
                                on: { change: _vm.onSelectRule },
                                model: {
                                  value: _vm.column_selected.rules,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.column_selected, "rules", $$v)
                                  },
                                  expression: "column_selected.rules",
                                },
                              })
                            : _vm._e(),
                          _vm.edit_rule || _vm.view_rule
                            ? _c(VTextField, {
                                attrs: {
                                  disabled: "",
                                  outlined: "",
                                  dense: "",
                                },
                                model: {
                                  value: _vm.column_selected.rule.name,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.column_selected.rule,
                                      "name",
                                      $$v
                                    )
                                  },
                                  expression: "column_selected.rule.name",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.column_selected.rules || _vm.column_selected.rule
                    ? _c(
                        VRow,
                        [
                          _vm.column_selected.rule
                            ? _c(VCol, [
                                _c(
                                  "fieldset",
                                  { staticClass: "fieldset p-3 mb-1" },
                                  [
                                    _c("legend", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "data_quality.dataplex.quality.column_field.rule_detail"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm.edit_rule || _vm.view_rule
                                      ? _c("DataplexRuleComponent", {
                                          ref: "FORM_RULE",
                                          attrs: {
                                            rule: _vm.column_selected.rule,
                                            view: _vm.view_rule,
                                            edit: _vm.edit_rule,
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.column_selected.rules
                            ? _c(
                                VTabs,
                                {
                                  staticClass: "col-12",
                                  attrs: { "show-arrows": "" },
                                  model: {
                                    value: _vm.tab_rule,
                                    callback: function ($$v) {
                                      _vm.tab_rule = $$v
                                    },
                                    expression: "tab_rule",
                                  },
                                },
                                _vm._l(_vm.matrix, function (item, index) {
                                  return _c(
                                    VTab,
                                    { attrs: { href: "#tab-" + index } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.column +
                                            " (" +
                                            item.rule.name +
                                            ")"
                                        )
                                      ),
                                    ]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm.column_selected.rules
                            ? _c(
                                VTabsItems,
                                {
                                  staticClass: "col-12",
                                  model: {
                                    value: _vm.tab_rule,
                                    callback: function ($$v) {
                                      _vm.tab_rule = $$v
                                    },
                                    expression: "tab_rule",
                                  },
                                },
                                _vm._l(_vm.matrix, function (item, index) {
                                  return _c(
                                    VTabItem,
                                    {
                                      key: index,
                                      attrs: { value: "tab-" + index },
                                    },
                                    [
                                      _c(
                                        VRow,
                                        [
                                          _c(VCol, { staticClass: "mt-2" }, [
                                            _c(
                                              "fieldset",
                                              {
                                                staticClass:
                                                  "fieldset p-3 mb-1",
                                              },
                                              [
                                                _c("legend", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "data_quality.dataplex.quality.column_field.rule_detail"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm.column_selected.rules &&
                                                _vm.column_selected.rules
                                                  .length > 0 &&
                                                !_vm.edit_rule &&
                                                !_vm.view_rule
                                                  ? _c(
                                                      "DataplexRuleComponent",
                                                      {
                                                        ref: "FORM_RULE",
                                                        refInFor: true,
                                                        attrs: {
                                                          rule: item.rule,
                                                          view: _vm.view_rule,
                                                          edit: _vm.edit_rule,
                                                        },
                                                      }
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "template",
            { slot: "btnsRight" },
            [
              !_vm.view_rule
                ? _c(
                    VBtn,
                    {
                      attrs: { color: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.edit_rule ? _vm.editColumn() : _vm.addColumn()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { small: "" } }, [
                        _vm._v("mdi-check-circle-outline"),
                      ]),
                      _vm._v(
                        _vm._s(
                          _vm.edit_rule
                            ? _vm.$t("botones.boton_update")
                            : _vm.$t("botones.boton_add")
                        )
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }